

























import OrderItem from '@spa/components/pages/order/order/order-list/read-only/OrderItem.vue'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { OrderKind } from '@/models/order/order'
import { CartItem } from '@spa/store/modules/cart/types'

@Component({
  components: {
    OrderItem,
  },
})
export default class OrderListItem extends Vue {
  @Prop({ required: true })
  readonly orderKind: OrderKind

  @Prop({ required: true })
  readonly deliveryWhen: string | null

  @Prop({ required: true })
  readonly cartItems: CartItem[]

  get labelDeliveryWhen(): string {
    const when = this.deliveryWhen

    if (this.orderIsPreOrder) {
      return `${when}頃を予定`
    }

    return when === null ? '未指定' : when
  }

  get orderIsPreOrder(): boolean {
    return this.orderKind === 'preorder'
  }

  get showItems(): CartItem[] {
    return this.cartItems.filter(c => !c.isChild)
  }
}
